import React, {ReactElement} from 'react';

import {Helmet} from 'react-helmet-async';

export default function AppHelmet(): ReactElement {
  return (
    <Helmet>
      <meta content="Neu Pro watch face promo page" name="description" />
      {/* Meta Pixel */}
      <script>
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('consent', 'revoke');
        fbq('init', '427974807051131');
        fbq('track', 'PageView');
        `}
      </script>
      <noscript>
        {`<img
          height="1"
          src="https://www.facebook.com/tr?id=427974807051131&ev=PageView&noscript=1"
          style="display:none"
          width="1"
        />`}
      </noscript>
      {/* Reddit Pixel */}
      <script>
        {`!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
          // We do these once the consent is given
          // rdt('init','a2_fkxof39zpg71');
          // rdt('track', 'PageVisit');
        `}
      </script>
      {/* Tiktok Pixel */}
      <script>
        {`!function (w, d, t) {
            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
          var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
          ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
            // We do these once the consent is given
            // ttq.load('D6M6PURC77U160FICAIG');
            // ttq.page();
          }(window, document, 'ttq');`}
      </script>
    </Helmet>
  );
}

// Reddit Pixel ID: a2_fkxof39zpg71
